<div [ngStyle]="showEndOtp?{'border-bottom': '1px solid #e0e0e0', 'margin-bottom':'8px', 'padding-bottom':'4px'}:{}">
    <div class="displayFlexRow">
        <span class=" otpDigits background-10ADAE fs-12" *ngFor="let otp of startOtp">
            {{otp}}
        </span>
    </div>
    <div class="otpText mt-4">
        {{startText}}
    </div>
</div>
<div *ngIf="showEndOtp">
    <div class="displayFlexRow">
        <span class=" otpDigits background-0087B2 fs-12" *ngFor="let otp of endOtp">
            {{otp}}
        </span>
    </div>
    <div class="otpText mt-4">
        {{endText}}
    </div>
</div>